import ReachAlert from '@reach/alert';
import classNames from 'classnames';
import IconInfoCircleOutline from '@picsart/icons/IconInfoCircleOutline';
import IconCrossLarge from '@picsart/icons/IconCrossLarge';

import { Button } from '../Button/Button';

import useStyles from './styles';
import { IErrorAlert } from './types';

function ErrorAlert({ onClose, className, description }: IErrorAlert) {
  const classes = useStyles();

  return (
    <div className={classNames(classes.container, className)}>
      <div className={classNames(classes.alert)}>
        <IconInfoCircleOutline fill="#080808" />

        <ReachAlert type="polite" className={classes.textContent}>
          <p className={classNames(classes.description)}>
            {description} <label className={classes.label}></label>
          </p>
        </ReachAlert>
        {onClose && (
          <Button className={classes.btnClose} variant="icon">
            <IconCrossLarge fill="#080808" onClick={onClose} />
          </Button>
        )}
      </div>
    </div>
  );
}

export default ErrorAlert;
